define('services/navHelper',[
    'lib/lodash',
    'services/embeddingService'
], function (
    _,
    embeddingService
) {
    'use strict';

    function hashify(path) {
        if (path[0] !== '#') {
            return '#' + path;
        } else {
            return path;
        }
    }

    return {
        navigateTo: function (newPath, options) {
            options = _.assign({ newWindow: false }, options);
            embeddingService.requestNavigation(hashify(newPath), options);
        },
        redirectTo: function (newPath) {
            embeddingService.requestRedirect(hashify(newPath));
        },
        back: function () {
            embeddingService.notifyBackNavigation();
        }
    };

});

